import React from 'react';
import { Section } from './ui/Section';
export function SocialProof() {
  const stats = [{
    value: '+1.200',
    label: 'Mujeres que ya auditaron su piel'
  }, {
    value: '8',
    label: 'Tomos + Bonos incluidos'
  }, {
    value: '4.9/5',
    label: 'Calificación ⭐'
  }, {
    value: 'España',
    label: 'Mercado principal'
  }];
  return <Section className="py-8 md:py-12" data-id="element-207">
      <div className="bg-white border border-neutral-200 rounded-2xl p-8 shadow-sm" data-id="element-208">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-209">
          {stats.map((stat, i) => <div key={i} className="space-y-2" data-id="element-210">
              <div className="font-display text-3xl md:text-4xl font-bold text-brand-cta" data-id="element-211">
                {stat.value}
              </div>
              <div className="font-heading text-xs md:text-sm text-brand-subtitle font-semibold uppercase tracking-wider" data-id="element-212">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}